export default __webpack_public_path__ + "static/media/silver-trophy.a45099aa.png";